module.exports = __webpack_public_path__ + "static/media/11.a5ce20d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/11.png
// module id = 377
// module chunks = 0